import { render, staticRenderFns } from "./PanelEditor.vue?vue&type=template&id=6848a23d"
import script from "./PanelEditor.vue?vue&type=script&lang=js"
export * from "./PanelEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports